import { base_url } from "../api/baseURL";

export const scrollY_to_target = (page: string) => {
  const target = document.getElementById(`${page}`);
  target?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const width_detector = () => {
  return window.innerWidth > 1024 ? true : false;
};

export const width_detector_guide = () => {
  return window.innerWidth > 1650 ? true : false;
};

export const download_json = (
  data: any,
  file_name: string,
  contentType: string | null
) => {
  const anchor = document.createElement("a"); // 링크생성
  const file = new Blob([JSON.stringify(data)], {
    type: contentType || "application/json",
  }); // json data 받아서 stringfy 통해 Json string 화
  anchor.href = URL.createObjectURL(file); //href 붙이고
  anchor.download = `${file_name}.imols.key.json`; // 파일명 설정하기.
  anchor.click(); // 링크 클릭시키기.
};

export const getPagesHeightById = (pages:string[]) => {
  const heights: number[] = [];
  pages.map((page) => {
    const pages_height = document.getElementById(`${page}`)?.scrollHeight;
    if (pages_height) heights.push(pages_height);
    return
  });
  const offset = 200;
  if (
    window.scrollY >=
    heights[0] + heights[1] + heights[2] + heights[3] - offset
  ) {
    return pages[pages.length - 1];
  }
  if (window.scrollY >= heights[0] + heights[1] + heights[2] - offset) {
    return pages[pages.length - 2];
  }
  if (window.scrollY >= heights[0] + heights[1] - offset) {
    return pages[pages.length - 3];
  }
  if (window.scrollY >= heights[0] - offset) {
    return pages[pages.length - 4];
  }
  // }
  return pages[0];
};

interface IServerVersion {
  code: number;
  version: {
    build_date: string;
    version: string;
  };
}

const log_version = async () => {
  const json: IServerVersion = await (
    await fetch(`${base_url()}/version`)
  ).json();
  console.log(
    `---------------------
    \n\n Front  : ${process.env.REACT_APP_VERSION_CODE} 
    \n Server : ${json.version.version} 
    \n\n---------------------`
  );
};

log_version();
